module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    attrs: {
      "id": "query"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("订单查询")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certNo),
      expression: "certNo"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入身份证号码",
      "maxlength": "18"
    },
    domProps: {
      "value": (_vm.certNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.certNo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "100%",
      "font-size": "15px"
    },
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.queryOrder
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('popup', {
    ref: "popupShows"
  }), _vm._v(" "), _c('ajaxLoading', {
    ref: "loading"
  }), _vm._v(" "), _c('maskPopup', {
    ref: "maskShow"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11c4ed8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/orderQuery.vue
// module id = 468
// module chunks = 1